import {
    askApi,
    companyUrl,
    companyEmployUrl,
    companyEmployInviteUrl,
    registerUrl,
    authBaseUrl,
    accessDepartmentUrl,
    meUrl,
    myCertificatesUrl,
    userUrl,
    depUrl,
    depUsersUrl,
    depInviteUrl,
    bankIdUrl,
    bankIdCollectUrl,
    certViewUrl,
    logoutUrl,
    profileUrl,
    mergeUsersUrl,
    ID06ConsentUrl,
    apiDomain,
} from '../endpoints';

export function setToken(token) {
    askApi.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export function clearToken() {
    delete askApi.defaults.headers.common['Authorization'];
}

export function getAuthResponse() {
    return new Promise((resolve) => {
        askApi.post(bankIdUrl).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function collectBankId(query, data) {
    return new Promise((resolve) => {
        askApi
            .get(bankIdCollectUrl, {
                params: { order_ref: query, qrToken: data.qrStartToken, qrSecret: data.qrStartSecret, t: data.time },
            })
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.data.token) {
                        const token = response.data.data.token.split('|').pop();

                        setToken(token);
                        localStorage.setItem('system_cache', JSON.stringify({ token: token }));

                        resolve({
                            data: {
                                hintCode: response.data.data.hintCode,
                                token: JSON.parse(localStorage.system_cache).token,
                                departments: response.data.data.departments,
                            },
                        });
                    } else {
                        resolve(response.data);
                    }
                }
            });
    });
}

export function registerUser(payload) {
    return new Promise((resolve) => {
        askApi.post(registerUrl, payload).then((response) => {
            if (response.status === 200) {
                if (response.data.data && response.data.data.token) {
                    const token = response.data.data.token.split('|').pop();

                    setToken(token);
                    localStorage.setItem('system_cache', JSON.stringify({ token: token }));
                }

                resolve(response.data);
            }
        });
    });
}

export function registerProfile(payload) {
    return new Promise((resolve) => {
        askApi.post(profileUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function mergeUsers(payload) {
    return new Promise((resolve) => {
        askApi.post(mergeUsersUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function getCompany(payload) {
    const query = {
        params: {
            organization_number: payload.organization_number,
        },
    };

    return new Promise((resolve) => {
        askApi.get(companyUrl, query).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function getEmployCompany(payload) {
    const query = {
        params: {
            organization_number: payload.organization_number,
        },
    };

    return new Promise((resolve) => {
        askApi.get(companyEmployUrl, query).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function getClientData(payload) {
    const query = {
        params: {
            invite_id: payload.invite_id,
        },
    };

    return new Promise((resolve) => {
        askApi.get(companyEmployInviteUrl, query).then((response) => {
            if (response && response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function accessDepartment(payload) {
    return new Promise((resolve) => {
        askApi.post(accessDepartmentUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function createCompany(payload) {
    return new Promise((resolve) => {
        askApi.post(depUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function loginUser(payload) {
    return new Promise((resolve) => {
        askApi.post(`${authBaseUrl}/login`, payload).then((response) => {
            if (response && response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
export function resetPassword(payload) {
    return new Promise((resolve) => {
        askApi.post(`${authBaseUrl}/reset-password`, payload).then((response) => {
            if (response && response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
export function updatePassword(payload) {
    return new Promise((resolve) => {
        askApi.put(`${authBaseUrl}/reset-password`, payload).then((response) => {
            if (response && response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function logoutUser() {
    return new Promise((resolve) => {
        askApi.post(logoutUrl).then((response) => {
            if (response && response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function getMe() {
    return new Promise((resolve, reject) => {
        askApi.get(meUrl).then((response) => {
            if (response && (response.status === 200 || response.status === 206)) {
                resolve(response.data);
            } else {
                reject(response);
            }
        });
    });
}

export function getMyCertificates() {
    return new Promise((resolve, reject) => {
        askApi.get(myCertificatesUrl).then((response) => {
            if (response && (response.status === 200 || response.status === 206)) {
                resolve(response.data);
            } else {
                reject(response);
            }
        });
    });
}

export function listDepartments() {
    return new Promise((resolve) => {
        askApi.get(depUrl).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function updateUser(payload) {
    return new Promise((resolve) => {
        askApi.patch(userUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function departmentUsers() {
    return new Promise((resolve) => {
        askApi.get(depUsersUrl).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function EmployDepartmentUsers() {
    return new Promise((resolve) => {
        askApi.get(`${apiDomain}/employ/employees`).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function invite(payload) {
    return new Promise((resolve) => {
        askApi.post(depInviteUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function certificatedUser(id, payload) {
    return new Promise((resolve) => {
        askApi.get(`${certViewUrl}/${id}`, { params: payload }).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function deleteUser() {
    return new Promise((resolve) => {
        askApi.delete(userUrl).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function deleteProfile(profile_id) {
    return new Promise((resolve) => {
        askApi.delete(`${profileUrl}/${profile_id}`).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function giveConsentID06() {
    return new Promise((resolve) => {
        askApi.post(ID06ConsentUrl).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
